import { getTvObject, tv } from '@costar-ui/cosmos';

var listBoxItemTV = getTvObject({
  base: ['group', 'relative', 'flex', 'cursor-default', 'select-none', 'items-center', 'gap-8', 'px-2', 'py-1.5', 'will-change-transform', 'border', 'border-transparent', 'data-[focused]:border-focus'],
  variants: {
    isSelected: {
      "false": ['text-on-base', 'hover:bg-accent-hover', 'hover:text-on-accent-hover'],
      "true": ['bg-action-selected', 'text-on-action-selected']
    },
    isDisabled: {
      "true": ['bg-transparent', 'text-on-action-disabled']
    }
  }
});
var base = tv(listBoxItemTV);
var listBoxItemStyles = {
  base: base
};

export { listBoxItemStyles };
//# sourceMappingURL=list-box-item.styles.esm.js.map
